import React from 'react';
import Card from 'antd/lib/card';
import './index.scss';
import { Button } from 'antd';

const ContentCard = (props) => {
    if (props.tabList && props.tabList.length) {
        return (
            <Card tabList={props.tabList} activeTabKey={props.activeTabKey} tabBarExtraContent={props.tabExtra} onTabChange={props.onTabChange} className={`mb-3 eb-content-card shadow-sm ${props.className}`} bordered={props.bordered} style={props.style}>
                {props.children}
            </Card>
        )
    }

    return (
        <Card className={`mb-3 eb-content-card shadow-sm ${props.className}`} bordered={props.bordered} style={props.style}>
            {props.children}
        </Card>
    )
}

ContentCard.defaultProps = {
    bordered: true,
    className: "",
    tabList: [],
}

export { ContentCard };